import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import _get from "lodash/get";
import _reduce from "lodash/reduce";

var _createReducer2, _createReducer3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { combineReducers } from 'redux';
import { createReducer } from 'redux-act';
import { FACT_KEYS } from './constants';
import { evaluateFacts } from './actions';
export var INITIAL_STATE = {
  facts: {},
  pendingFacts: _reduce(FACT_KEYS, function (result, factKey) {
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, factKey, {
      pendingRequests: 0
    }));
  }, {}),
  errors: {}
};
/**
 *
 * Helper functions
 *
 */

/**
 * @param {number} delta the amount by which to update the pendingRequests count for each factKey
 * @return {function} a reducer function that updates the pendingRequests count for each fact key
 * requested in a `evaluateFacts` action
 */

var makeUpdatePendingRequestsCountForEvaluateFactsAction = function makeUpdatePendingRequestsCountForEvaluateFactsAction(delta) {
  return function (state, payload, _ref) {
    var factKeys = _ref.facts;
    return _reduce(factKeys, function (result, factKey) {
      var prevPendingRequestsCount = _get(state, [factKey, 'pendingRequests'], 0);

      var newPendingRequestsCount = prevPendingRequestsCount + delta;
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, factKey, newPendingRequestsCount ? {
        pendingRequests: newPendingRequestsCount
      } : undefined));
    }, state);
  };
};

var incrementPendingRequests = makeUpdatePendingRequestsCountForEvaluateFactsAction(1);
var decrementPendingRequests = makeUpdatePendingRequestsCountForEvaluateFactsAction(-1);
/**
 *
 * Reducers
 *
 */

var factsReducer = createReducer(_defineProperty({}, evaluateFacts.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), payload.facts);
}), INITIAL_STATE.facts);
var pendingFactsReducer = createReducer((_createReducer2 = {}, _defineProperty(_createReducer2, evaluateFacts.start, incrementPendingRequests), _defineProperty(_createReducer2, evaluateFacts.success, decrementPendingRequests), _defineProperty(_createReducer2, evaluateFacts.fail, decrementPendingRequests), _createReducer2), INITIAL_STATE.pendingFacts);
/**
 * Even if the evaluateFacts call returns a 200, one or more facts may have failed.  This reducer
 * stores those errors for (a) debugging purposes, and (b) in case the feature needs to handle
 * certain evaluation errors in specific ways.
 */

var errorsReducer = createReducer((_createReducer3 = {}, _defineProperty(_createReducer3, evaluateFacts.success, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), _get(payload, 'errors'));
}), _defineProperty(_createReducer3, evaluateFacts.fail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), _get(payload, 'errors'));
}), _createReducer3), INITIAL_STATE.errors);
export default combineReducers({
  facts: factsReducer,
  pendingFacts: pendingFactsReducer,
  errors: errorsReducer
});